import { render, staticRenderFns } from "./AdvertiserDetails.vue?vue&type=template&id=0a9926a6"
import script from "./AdvertiserDetails.vue?vue&type=script&lang=js"
export * from "./AdvertiserDetails.vue?vue&type=script&lang=js"
import style0 from "./AdvertiserDetails.vue?vue&type=style&index=0&id=0a9926a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports